<template>
    <div class="page-header signup-page section-imageTTT">
        <!-- <div class="page-header-image"
             style="background-image: url('img/bg3.jpg')">
        </div> -->
        <parallax class="page-header-image"
            style="background-image: url('img/sarel/loginpagegraphic.jpeg')">
        </parallax>
        <!-- <div class="content"> -->
        <div class="content-center">
            <div class="container">
                <div class="row">
                    <div class="col-md-5 ml-auto mr-auto">
                        <div class="card card-signup">
                            <div class="card-body">
                                <form @submit.prevent="login">
                                    <h4 v-if="user.name" class="card-title text-center">Welcome {{ user.name }}</h4>
                                    <h4 v-else class="card-title text-center">Sign in</h4>

                                        <div v-if="this.authError.mess" class="alert alert-danger" role="alert">
                                            {{ this.authError.mess }}
                                        </div>

                                        <!-- <div v-if="this.authError.hasOwnProperty('errors')" class="">
                                            <div v-if="this.authError.errors.hasOwnProperty('email')" class="card-description">
                                                <template v-for="(item, index) in this.authError.errors.email">
                                                    {{ item }}
                                                </template>
                                            </div>
                                            <div v-if="this.authError.errors.hasOwnProperty('password')" class="card-description">
                                                <template v-for="(item, index) in this.authError.errors.password">
                                                    {{ item }}
                                                </template>
                                            </div>
                                        </div> -->

                                    <h5 v-if="false && this.userId" class="card-description">
                                        User ID: {{ this.userId }}
                                    </h5>
                                    <fg-input addon-left-icon="now-ui-icons users_circle-08"
                                        v-model="form.email"
                                        placeholder="Email..."
                                        :rules="emailRules"
                                        required
                                        :error="this.emailFeedback"
                                        type="email">
                                    </fg-input>

                                    <fg-input addon-left-icon="now-ui-icons objects_key-25"
                                        placeholder="Password..."
                                        v-model="form.password"
                                        :rules="passwordRules"
                                        required
                                        :error="this.passFeedback"
                                        type="password">
                                    </fg-input>

                                    <div class="card-footer text-center">
                                        <!-- <n-button @click.native="login(null)" type="primary" round size="lg">Submit</n-button> -->
                                        <button type="submit" class="btn btn-roundTTT btn-primary btn-lg">Submit</button>
                                    </div>
                                </form>

                                <div class="row">
                                    <div v-if="false" class="col-sm">
                                        <router-link to="/signup">
                                            <a class="nav-link" style="font-size:12px">
                                            Signup
                                            </a>
                                        </router-link>
                                    </div>
                                    <div class="col-sm">
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <main-footer></main-footer> -->
    </div>
</template>
<script>
  import { Card, Button, FormGroupInput, Checkbox } from '@/components';
  //import MainFooter from '@/layout/MainFooter';

  import { mapGetters } from 'vuex'

  export default {
    name: 'login-page',
    bodyClass: 'login-page',
    components: {
      Card,
      //MainFooter,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [FormGroupInput.name]: FormGroupInput
    },
    data() {
      return {
        user: {
            name: null,
            email: null
        },
        form: {
            email: null,
            password: null,
            //google_user_id: null
        },
        emailRules: [
            v => !!v || 'E-mail is required',
            v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        ],
        passwordRules: [
                v => !!v || 'Password is required!!!!'
        ],
      }
    },
    computed: {
        ...mapGetters(['authError']),
        userId: function() {
            return this.userInfo.id
        },
        emailFeedback: function() {
            if (this.authError.hasOwnProperty('errors') && this.authError.errors.hasOwnProperty('email')) {
                return this.authError.errors.email[0]
            } else {
                return ''
            }
        },
        passFeedback: function() {
            if (this.authError.hasOwnProperty('errors') && this.authError.errors.hasOwnProperty('password')) {
                return this.authError.errors.password[0]
            } else {
                return ''
            }
        },
    },
    methods: {
        //onSubmit () {},
        async login(mode) {
            switch (mode) {
                case 'google':
                    var googleUser = await this.$gAuth.signIn()
                    this.user.name = googleUser.getBasicProfile().GV
                    this.form.email = googleUser.getBasicProfile().bu
                    this.form.google_user_id = googleUser.getId()
                    if(User.login(this.form)) {
                        router.push('signup')
                    }
                    break;
                case 'facebook':

                    break;

                default:
                    //User.login(this.form)
                    //console.log(this.form)
                    this.$store.dispatch('login', {email: this.form.email, password: this.form.password})
                    break;
            }
        },
        async getGoogleAuthCode() {
            const authCode = await this.$gAuth.getAuthCode()
            console.log('google-code', authCode)
        },

        // getCode() {
        //     console.log('get that code')
        // }
    }
  }
</script>
<style>
</style>
